import { render, staticRenderFns } from "./IconSuperisolerend.vue?vue&type=template&id=522e5da6&scoped=true"
import script from "./IconSuperisolerend.vue?vue&type=script&lang=ts"
export * from "./IconSuperisolerend.vue?vue&type=script&lang=ts"
import style0 from "./IconSuperisolerend.vue?vue&type=style&index=0&id=522e5da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e5da6",
  null
  
)

export default component.exports